import contentTemplate from 'properties/main/mobile-form.ejs';
import BasePropertyView from 'BasePropertyView.js';
import constants from 'Constants';
import eventBus from '../../../service/EventBus';
import listService from '../../../service/ListService';
import mobileConstants from '../../../mobile/commons/MobileFormsConstants';

class MobileMainFormView extends BasePropertyView {

    initialize(opts) {
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.config = opts.config || {};

        this.events = {
            'change #mainMarginSize': 'updateMarginSize',
            'click .margin-optionButton': 'setMargin'
        };

        return this;
    }

    setSelectedOptions() {
        $(".margin-optionButton").removeClass("selected");
        $(`svg[data-margin=${this.model.get("defaultMargin")}]`).addClass("selected");
    }

    setMargin(ev) {
        ev.preventDefault();
        this.updateSelectedMargin(ev.currentTarget);
    }

    updateSelectedMargin(currentTarget){
        let selectedOption = currentTarget.getAttribute("data-margin");
        this.model.set("defaultMargin", selectedOption, constants.MODEL_SILENT);
        this.setSelectedOptions();
        eventBus.trigger(constants.EV_UPDATE_MARGIN_FROM_FORM, selectedOption, false);
    }

    updateMarginSize(event){
        event.preventDefault();
        let value = event.currentTarget.value;
        this.model.set("defaultMarginSize", value, constants.MODEL_SILENT);
        eventBus.trigger(constants.EV_UPDATE_MARGIN_FROM_FORM, value, true);       
    }

    render() {
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));
        this.setSelectedOptions();
        this.delegateEvents();
        return this;
    }
}

export default MobileMainFormView;